export * from "./manual-test.component";
export * from "./manual-test.module";
